import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { Field, Panel } from "@/components/admin/shared";

const empty = { current: "", next: "", confirm: "" };

export const PasswordPanel = () => {
  const [f, setF] = useState(empty);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 8) return toast.error("La nueva contraseña debe tener al menos 8 caracteres");
    if (f.next !== f.confirm) return toast.error("Las contraseñas nuevas no coinciden");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Contraseña actualizada. Úsala la próxima vez que entres.");
      setF(empty);
    } catch (err) { toast.error(errorText(err)); }
    setBusy(false);
  };
  return (
    <Panel title="Cambiar contraseña">
      <form onSubmit={submit} className="grid gap-4 sm:grid-cols-3" data-testid="change-password-form">
        <Field id="pw-current" label="Contraseña actual" type="password" autoComplete="current-password" required value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} />
        <Field id="pw-new" label="Nueva contraseña (mín. 8)" type="password" autoComplete="new-password" required value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} />
        <Field id="pw-confirm" label="Repite la nueva" type="password" autoComplete="new-password" required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} />
        <div className="sm:col-span-3"><button className="btn-gold" disabled={busy} data-testid="change-password-submit-btn">{busy ? <Loader2 size={16} className="animate-spin" /> : <KeyRound size={16} />} Cambiar contraseña</button></div>
      </form>
    </Panel>
  );
};
